import type { StepView } from '~/helpers/learner/session-view'
import { useTranslation } from 'react-i18next'
import { useBranding } from '~/helpers/branding/branding-context'
import { formatSessionDate } from '~/helpers/dates/session-dates'
import { lockReasonMessage } from '~/helpers/learner/lock-reason'

/**
 * Raison de fermeture d'une étape, traduite — date formatée dans le fuseau de
 * l'organisation, comme partout ailleurs (#194). Cf. `lockReasonMessage`.
 */
export function useLockReason(dateOptions?: Intl.DateTimeFormatOptions): (step: StepView, steps: StepView[]) => string {
  const { t, i18n } = useTranslation()
  const { timezone } = useBranding()

  return (step, steps) => {
    const { key, values } = lockReasonMessage(
      step,
      steps,
      date => formatSessionDate(date, i18n.language, timezone, dateOptions),
    )
    return t(key, values)
  }
}
